// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "content-lFQ5L";
var _3 = "name-1MryT";
var _4 = "iata-2plOC";
export { _1 as "__esModule", _2 as "content", _3 as "name", _4 as "iata" }
export default { "__esModule": _1, "content": _2, "name": _3, "iata": _4 }
